import React from "react";
import { useSearchParams } from "react-router-dom";
import WritingAssistantPersonasPanel from "../Monitoring/WritingAssistantPersonasPanel";
import WritingAssistantBrandGuidelinesPanel from "../Monitoring/WritingAssistantBrandGuidelinesPanel";

const VALID_SETTINGS_TABS = ["personas", "guidelines"];
const SETTINGS_TABS = [
	{ id: "personas", label: "Personas" },
	{ id: "guidelines", label: "Brand Guidelines" },
];

export default function ContentStudioSettingsPanel({ websiteId }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const tabParam = searchParams.get("tab");
	const tab = VALID_SETTINGS_TABS.includes(tabParam) ? tabParam : "personas";

	function setTab(nextTab) {
		const next = new URLSearchParams(searchParams);
		if (nextTab === "personas") {
			next.delete("tab");
		} else {
			next.set("tab", nextTab);
		}
		setSearchParams(next, { replace: true });
	}

	return (
		<div className="monitoring__writing-settings">
			<nav
				className="monitoring__tabs"
				role="tablist"
				aria-label="Content Studio settings sections"
			>
				{SETTINGS_TABS.map((item) => (
					<button
						key={item.id}
						type="button"
						role="tab"
						aria-selected={tab === item.id}
						className={`monitoring__tab${
							tab === item.id ? " monitoring__tab--active" : ""
						}`}
						onClick={() => setTab(item.id)}
					>
						{item.label}
					</button>
				))}
			</nav>

			<div className="monitoring__writing-tab-panel" role="tabpanel">
				{tab === "guidelines" ? (
					<WritingAssistantBrandGuidelinesPanel websiteId={websiteId} />
				) : (
					<WritingAssistantPersonasPanel websiteId={websiteId} />
				)}
			</div>
		</div>
	);
}
